module.exports = __webpack_public_path__ + "static/media/2fer-white.fe51fec5.svg";